<template>
  <li>
    <div
      :class="[
        selectedPath === parentPath + 'altContent' ? 'focused' : '',
        errorPath.includes(parentPath + 'altContent') ? 'has-error' : '',
      ]"
      @click="selectNode(video, parentPath + 'altContent')"
      @mouseenter="isHover = true"
      @mouseleave="isHover = false"
    >
      <span class="node-icon">
        <q-icon
          size="xs"
          name="arrow_drop_down"
        />
      </span>
      <span>video</span>
    </div>
    <ul>
      <Box
        :box="video.altContent"
        :parentPath="parentPath + 'altContent.'"
        :selectedNode="selectedNode"
        :selectedPath="selectedPath"
        :errorPath="errorPath"
        @onSelectNode="selectNode"
        @onHoverNode="(val) => $emit('onHoverNode', val)"
        v-if="video.altContent?.type === 'box'"
      />
      <Image
        :image="video.altContent"
        :parentPath="parentPath + 'altContent.'"
        :selectedNode="selectedNode"
        :selectedPath="selectedPath"
        :errorPath="errorPath"
        @onSelectNode="selectNode"
        @onHoverNode="(val) => $emit('onHoverNode', val)"
        v-if="video.altContent?.type === 'image'"
      />
    </ul>
  </li>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import {
  IFlexMessageBox,
  IFlexMessageBubble,
  IFlexMessageButton,
  IFlexMessageCarousel,
  IFlexMessageFiller,
  IFlexMessageIcon,
  IFlexMessageImage,
  IFlexMessageSeparator,
  IFlexMessageSpan, IFlexMessageText,
  IFlexMessageVideo,
} from '@/utils/types'
import Box from '@/components/common/flex-message/nodes/Box.vue'
import Image from '@/components/common/flex-message/nodes/Image.vue'

@Options({
  components: { Image, Box },
  directives: { maska },
  emits: ['onSelectNode', 'onHoverNode'],
})
export default class Video extends Vue {
  @Prop()
  video!: IFlexMessageVideo

  @Prop()
  selectedNode!: IFlexMessageCarousel | IFlexMessageBubble | IFlexMessageBox | IFlexMessageButton | IFlexMessageFiller | IFlexMessageIcon | IFlexMessageImage | IFlexMessageSeparator | IFlexMessageSpan | IFlexMessageText | IFlexMessageVideo

  @Prop()
  selectedPath!: string

  @Prop()
  parentPath!: string

  @Prop()
  errorPath!: string[]

  isHover = false

  selectNode(node, path) {
    if (this.selectedNode === node && this.selectedPath === path) {
      this.$emit('onSelectNode', undefined, '')
    } else {
      this.$emit('onSelectNode', node, path)
    }
  }

  @Watch('isHover')
  onHover() {
    if (this.isHover) {
      this.$emit('onHoverNode', this.parentPath + 'altContent')
    }
  }
}
</script>

<style scoped lang="scss">

</style>
